import React, { FC } from 'react';
import { useFieldArray } from 'react-hook-form';
import { ImageCard } from './ImageCard';
import { StyledImageTray } from './ImageTray.styles';
import { InlineMessages, InlineMessagesType, Text, Types } from '@marriott/mi-ui-library';
import { RESLINK_IMAGE_TRAY_LENGTH } from '../../../../constants';
import { ImageTray as ImageTrayProps } from './ImageTray.types';

export const ImageTray: FC<ImageTrayProps> = ({
  title,
  images,
  control,
  uploadImageError,
  setUploadImageError,
  ...rest
}) => {
  const { fields, append, remove } = useFieldArray({
    control: control,
    name: 'customImages',
  });

  return (
    <StyledImageTray>
      {!!uploadImageError && (
        <div className="mb-4">
          <InlineMessages type={InlineMessagesType.Error} title={uploadImageError} severity="1" />
        </div>
      )}
      <Text
        element={Types.tags.paragraph}
        copyText={title}
        fontSize={Types.size.medium}
        customClass={'mb-5 col-md-11'}
      />
      <div className="image-cards">
        {Array.from({ length: RESLINK_IMAGE_TRAY_LENGTH }, (_, index: number) => (
          <ImageCard
            {...rest}
            key={index}
            index={index}
            image={images?.[index]}
            fields={fields}
            append={append}
            remove={remove}
            onError={setUploadImageError}
          />
        ))}
      </div>
    </StyledImageTray>
  );
};
